module.exports = __webpack_public_path__ + "img/B3.3c1a85c3.jpg";